import React from 'react'
import InfoIcon from 'SVGS/InfoIcon'
import { Tooltip } from 'react-tooltip'


const CustomLabel = ({ label, labelClass, toolTip, required, Icon, tooltipWidth = 220, ...labelProps }) => {
    const IconComponent = Icon || InfoIcon;

    return (
        <div>
            <label
                {...labelProps}
                className={`text-secondary font-medium text-sm ${labelClass} ${required && " required"}`}   >
                {label}

            </label>
            {toolTip && <> <IconComponent className={`inline ${labelProps.iconClass}`} size={14} data-tooltip-id={`${label}-tooltip`} data-tooltip-content={toolTip} />
                <Tooltip id={`${label}-tooltip`} style={{ zIndex: 2, maxWidth: tooltipWidth }} /></>}

        </div>


    )
}

export default CustomLabel